@if (showMonthJump()) {
<lib-button
  [iconSvg]="skipToStart"
  variant="ghost"
  [size]="size()"
  [color]="color()"
  [disabled]="isPrevDisabled()"
  [title]="monthPrevTitle()"
  class="msa-dn__jump msa-dn__jump--month"
  (clicked)="onMonthPrev()"
/>
}
@if (showWeekJump()) {
<lib-button
  [iconSvg]="chevronDoubleLeft"
  variant="ghost"
  [size]="size()"
  [color]="color()"
  [disabled]="isPrevDisabled()"
  [title]="weekPrevTitle()"
  class="msa-dn__jump msa-dn__jump--week"
  (clicked)="onWeekPrev()"
/>
}
@if (showWeekJump() || showMonthJump()) {
<span class="msa-dn__divider"></span>
}
<lib-button
  [iconSvg]="chevronLeft"
  variant="ghost"
  [size]="size()"
  [color]="color()"
  [disabled]="isPrevDisabled()"
  (clicked)="onPrev()"
/>
<span class="msa-dn__label">
  @if (icon()) {
    <span class="msa-dn__icon">{{ icon() }}</span>
  }
  @if (weekday()) {
    <span class="msa-dn__weekday">{{ weekday() }}</span
    >,
  }
  {{ label() }}
</span>
<lib-button
  [iconSvg]="chevronRight"
  variant="ghost"
  [size]="size()"
  [color]="color()"
  [disabled]="isNextDisabled()"
  (clicked)="onNext()"
/>
@if (showWeekJump() || showMonthJump()) {
<span class="msa-dn__divider"></span>
}
@if (showWeekJump()) {
<lib-button
  [iconSvg]="chevronDoubleRight"
  variant="ghost"
  [size]="size()"
  [color]="color()"
  [disabled]="isNextDisabled()"
  [title]="weekNextTitle()"
  class="msa-dn__jump msa-dn__jump--week"
  (clicked)="onWeekNext()"
/>
}
@if (showMonthJump()) {
<lib-button
  [iconSvg]="skipToEnd"
  variant="ghost"
  [size]="size()"
  [color]="color()"
  [disabled]="isNextDisabled()"
  [title]="monthNextTitle()"
  class="msa-dn__jump msa-dn__jump--month"
  (clicked)="onMonthNext()"
/>
}
